import axios from "../../api/axios";
import {
    cleanSelectedPayment,
    getAllPaymentsStart,
    getAllPaymentsSuccess,
    getAllPaymentsFailure,
    getAllPaymentsByUserIdStart,
    getAllPaymentsByUserIdSuccess,
    getAllPaymentsByUserIdFailure,
    getPaymentByIdStart,
    getPaymentByIdSuccess,
    getPaymentByIdFailure,
    uploadPaymentStart,
    uploadPaymentSuccess,
    uploadPaymentFailure,
    updatePaymentStart,
    updatePaymentSuccess,
    updatePaymentFailure,
    declinePaymentStart,
    declinePaymentSuccess,
    declinePaymentFailure,
    acceptedPaymentFailure,
    acceptedPaymentSuccess,
    acceptedPaymentStart,
} from "../reducers/payment";



/**
 * Listado de pagos (POST JSON): filtros, columnSearch, sort, Excel opcional.
 * POST /payment/getAllPayments
 */
export const getAllPayments = (payload = {}) => async (dispatch) => {
    const sendExcel = payload.sendExcel === true;
    if (!sendExcel) {
        dispatch(getAllPaymentsStart());
    }
    try {
        const response = await axios.post(`/payment/getAllPayments`, payload, {
            withCredentials: true,
        });
        if (response.status === 200) {
            if (!sendExcel) {
                dispatch(getAllPaymentsSuccess(response.data));
            }
            return {
                status: response.status,
                totalRows: response.data.total,
                page: response.data.page,
                pageSize: response.data.pageSize,
                excelData: response.data.excelData,
            };
        }
        return response.status;
    } catch (error) {
        if (!sendExcel) {
            dispatch(getAllPaymentsFailure());
        }
        return { status: error?.response?.status || 500 };
    }
};

export const getPaymentById = (paymentId) => async (dispatch) => {
    dispatch(getPaymentByIdStart());
    try {
        const response = await axios.get(`/payment/getPaymentById/${paymentId}`,
            {
                withCredentials: true,
            });
        dispatch(getPaymentByIdSuccess(response.data));
        return response.status;
    } catch (error) {
        dispatch(getPaymentByIdFailure());
    }
};

export const getAllPaymentByUserId = (userId) => async (dispatch) => {
    dispatch(getAllPaymentsByUserIdStart());
    try {
        const response = await axios.get(`/payment/getAllPaymentSubscriptionByUserId/${userId}`,
            {
                withCredentials: true,
            });
        dispatch(getAllPaymentsByUserIdSuccess(response.data));
        return response.status;
    } catch (error) {
        dispatch(getAllPaymentsByUserIdFailure());
    }
};

export const uploadPayment = ({
    userId,
    invoiceActive,
    file,
}) => async (dispatch) => {
    dispatch(uploadPaymentStart());
    try {
        const formData = new FormData();
        formData.append('file', file);
        formData.append("upload_preset", process.env.REACT_APP_PRESET_NAME);
        formData.append("cloud_name", process.env.REACT_APP_CLOUD_NAME);
        formData.append('upload_preset', 'fca-intranet');

        const res = await axios.post(`https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUD_NAME}/image/upload`, formData);


        if (res.status === 200) {
            const response = await axios.post('/payment/createPayment', {
                urlName: res.data.secure_url,
                publicId: res.data.public_id,
                userId,
                invoiceActive,
            });
            if (response.status === 201) {
                dispatch(uploadPaymentSuccess());
                return {
                    status: response.status,
                    message: response.data.message
                };
            }
        }
    } catch (error) {
        dispatch(uploadPaymentFailure());
    }
};

export const updateRejectedPaymentByStudent = ({
    userId,
    paymentId,
    publicId,
    file,
    updatedBy,
}) => async (dispatch) => {
    dispatch(updatePaymentStart());
    try {
        const formData = new FormData();
        formData.append('file', file);
        formData.append("upload_preset", process.env.REACT_APP_PRESET_NAME);
        formData.append("cloud_name", process.env.REACT_APP_CLOUD_NAME);
        formData.append('upload_preset', 'fca-intranet');

        const res = await axios.post(`https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUD_NAME}/image/upload`, formData);

        if (res.status === 200) {
            const response = await axios.put(`/payment/updatePayment/${paymentId}`, {
                urlName: res.data.secure_url,
                newPublicId: res.data.public_id,
                oldPublicId: publicId,
                changeImage: true,
                updatedBy: updatedBy
            });
            
            if (response.status === 200) {
                dispatch(updatePaymentSuccess());
                return {
                    status: response.status,
                    message: response.data.message
                };
            }
        }
    } catch (error) {
        dispatch(updatePaymentFailure());
        return {
            status: 500,
            message: error.response?.data?.message || 'Error al actualizar el comprobante de pago'
        };
    }
};

export const updatePayment = ({
    amount,
    account,
    file,
    publicId,
    paymentId,
    updatedBy,
}) => async (dispatch) => {
    dispatch(updatePaymentStart());
    try {
        if (file !== null) {
            const formData = new FormData();
            formData.append('file', file);
            formData.append("upload_preset", process.env.REACT_APP_PRESET_NAME);
            formData.append("cloud_name", process.env.REACT_APP_CLOUD_NAME);
            formData.append('upload_preset', 'fca-intranet');

            const res = await axios.post(`https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUD_NAME}/image/upload`, formData);


            if (res.status === 200) {
                const response = await axios.put(`/payment/updatePayment/${paymentId}`, {
                    urlName: res.data.secure_url,
                    newPublicId: res.data.public_id,
                    oldPublicId: publicId,
                    account: account._id,
                    amount: parseFloat(amount),
                    changeImage: true,
                    updatedBy: updatedBy
                });
                if (response.status === 200) {
                    dispatch(updatePaymentSuccess());
                    return {
                        status: response.status,
                        message: response.data.message
                    };
                }
            }
        } else {
            const response = await axios.put(`/payment/updatePayment/${paymentId}`, {
                account: account._id,
                amount: parseFloat(amount),
                changeImage: false,
                updatedBy: updatedBy
            });
            if (response.status === 200) {
                dispatch(updatePaymentSuccess());
                return {
                    status: response.status,
                    message: response.data.message
                };
            }
        }
    } catch (error) {
        dispatch(updatePaymentFailure());
    }
};

export const declinePayment = ({ email, message, paymentId, userId,  }) => async (dispatch) => {
    dispatch(declinePaymentStart());
    try {
        const response = await axios.put(`/payment/declinePayment/${paymentId}`,
            {
                email: email,
                userId: userId,
                message: message
            });
        if (response.status === 200) {
            dispatch(declinePaymentSuccess());
            return {
                status: response.status,
                message: response.data.message
            };
        }
    } catch (error) {
        dispatch(declinePaymentFailure());
    }
};

/**
 * Actualiza campos permitidos del pago (amount, account, paymentReceiptDate, paymentType, status, urlName, publicId, validatedBy).
 * Envía solo las claves que quieras cambiar más updatedBy (requerido).
 */
export const patchPayment = ({ paymentId, updatedBy, ...fields }) => async (dispatch) => {
    try {
        const body = { updatedBy, ...fields };
        if (fields.paymentReceiptDate instanceof Date) {
            body.paymentReceiptDate = fields.paymentReceiptDate.toISOString();
        }
        const response = await axios.patch(
            `/payment/patchPayment/${paymentId}`,
            body,
            { withCredentials: true }
        );
        if (response.status === 200) {
            dispatch(getPaymentById(paymentId));
            return {
                status: response.status,
                message: response.data.message,
                data: response.data.data,
            };
        }
        return {
            status: response.status,
            message: response.data?.message || 'Error al actualizar',
        };
    } catch (error) {
        return {
            status: error.response?.status || 500,
            message: error.response?.data?.message || 'Error al actualizar el pago',
        };
    }
};

export const acceptedPayment = ({ paymentDeadlineDate, paymentReceiptDate, email, paymentId, userId, updatedBy, validatedBy, paidWeeks, accountId, amount }) => async (dispatch) => {
    dispatch(acceptedPaymentStart());
    try {
        const response = await axios.put(`/payment/acceptedPayment/${paymentId}`,
            {
                paymentDeadlineDate: paymentDeadlineDate,
                paymentReceiptDate: paymentReceiptDate,
                email: email,
                userId: userId,
                updatedBy: updatedBy,
                validatedBy: validatedBy,
                paidWeeks: paidWeeks,
                accountId: accountId,
                amount: amount
            });
        if (response.status === 200) {
            dispatch(acceptedPaymentSuccess());
            return {
                status: response.status,
                message: response.data.message
            };
        }
    } catch (error) {
        dispatch(acceptedPaymentFailure());
    }
};


export const cleanActionSelectedPayment = () => async (dispatch) => {
    dispatch(cleanSelectedPayment());
};

export const checkStatusInvoice = (userId) => async (dispatch) => {
    try {
        const response = await axios.get(`/payment/getUserInvoiceStatus/${userId}`);
        if (response.status === 200) {
            return {
                status: response.status,
                data: {
                    invoiceStatus: response.data.invoiceStatus,
                    invoiceActive: response.data.invoiceActive
                }
            };
        }
    } catch (error) {
        console.log(error);
    }
};
